import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Star from '../components/Star';
import ParameterErrors from '../errors/ParameterErrors';
import IconButtonNonReact from '../components/IconButtonNonReact';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import Urls from '../urls/Urls';
import PlotDetailedInformationSectionType from './PlotDetailedInformationSectionType';
const {throwNotProvided}=ParameterErrors;
export default class PlotDetailedInformationSummary {
	constructor(props){
		const { siteJsonUnitPlot, addFavourite, removeFavourite, showStreetView, scrollToFloorPlans,
			scrollToGallery, configuration, showBrochureGenerationDialog, enterHouse}=props;
		this._callbackShowBrochureGenerationDialog = showBrochureGenerationDialog;
		this._callbackEnterHouse = enterHouse;
		this._configuration=configuration;
		this._selectedChanged = this._selectedChanged.bind(this);
		this._handleClickSendBrochure = this._handleClickSendBrochure.bind(this);
		this._handleClickEnterHouse = this._handleClickEnterHouse.bind(this);
		this._setValuesFromSiteJsonUnitPlot = this._setValuesFromSiteJsonUnitPlot.bind(this);
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._callbackAddFavourite = addFavourite;
		this._callbackRemoveFavourite = removeFavourite;
		this._callbackShowStreetView = showStreetView;
		this._handleStarSelectedChanged = this._handleStarSelectedChanged.bind(this);
		this._handleClickShowStreetView = this._handleClickShowStreetView.bind(this);
		this._element = document.createElement('div');
		this._element.classList.add('summary');
		this._plotNameElement = document.createElement('div');
		this._plotNameElement.classList.add('plot-name');
		this._plotNumberElement = document.createElement('div');
		this._plotNumberElement.classList.add('plot-number');
		this._plotStatusDescriptionElement = document.createElement('div');
		this._plotStatusDescriptionElement.classList.add('plot-status');
		this._plotPriceElement = document.createElement('div');
		this._plotPriceElement.classList.add('plot-price');
		this._nBedroomsElement = document.createElement('div');
		this._nBedroomsElement.classList.add('n-bedrooms');
		this._smallButtonsElement = document.createElement('div');
		this._smallButtonsElement.classList.add('small-buttons');
		[this._plotNameElement, this._plotNumberElement, this._plotStatusDescriptionElement, this._plotPriceElement, 
			this._nBedroomsElement, this._smallButtonsElement]
		.forEach(childElement=>this._element.appendChild(childElement));
		this._star = React.createRef();
		const starFactory = React.createFactory(Star);
		ReactDOM.render(starFactory(
			{ 
				onSelectedChange:this._handleStarSelectedChanged, 
				ref:this._star,
				stopEventPropagation:true
			}),
			this._smallButtonsElement);
		const hasOneOrMoreRoomImages=siteJsonUnitPlot.hasOneOrMoreRoomImages;
		if(configuration.outside360Enabled){
			this._iconButtonWalkmode = new IconButtonNonReact({ 	
				className:["button-show-street-view", "button-show"], 
				imgUrl:Urls.assets+'icons/UI_Button_Walkmode.png',
				onClick:this._handleClickShowStreetView
			});
			this._smallButtonsElement.appendChild(this._iconButtonWalkmode.element);
		}
			
		
		this._iconButtonShowGallery = new IconButtonNonReact({
				className:["button-show-gallery", "button-show"], 
				imgUrl:hasOneOrMoreRoomImages?(Urls.assets+'icons/UI_Button_Gallery.png'):(Urls.assets+'icons/UI_Button_Gallery_Disabled.png'),
				onClick:scrollToGallery
			});
		this._smallButtonsElement.appendChild(this._iconButtonShowGallery.element);
			
		
		this._iconButtonShowGallery = new IconButtonNonReact({
				className:["button-show-floor-plan", "button-show"], 
				imgUrl:Urls.assets+'icons/UI_Button_Floorplan.png',
				onClick:scrollToFloorPlans
			});
		this._smallButtonsElement.appendChild(this._iconButtonShowGallery.element);
		
		this._buttonEnterHouse = document.createElement('button');
		this._buttonEnterHouse.classList.add("button-enter-house");
		this._buttonEnterHouse.addEventListener('click', this._handleClickEnterHouse);
		this._buttonEnterHouse.innerHTML = 'Enter Plot';
		this._smallButtonsElement.appendChild(this._buttonEnterHouse);
		
		if(configuration.brochureGeneratorUrl){
			const buttonSendBrochure = document.createElement('button');
			buttonSendBrochure.classList.add("button-send-brochure");
			buttonSendBrochure.addEventListener('click', this._handleClickSendBrochure);
			buttonSendBrochure.innerHTML = 'Send Brochure';
			this._smallButtonsElement.appendChild(buttonSendBrochure);
		}
		
		this._setValuesFromSiteJsonUnitPlot(siteJsonUnitPlot);
	}
	set plot(siteJsonUnitPlot){
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._setValuesFromSiteJsonUnitPlot(siteJsonUnitPlot);
	}
	_setValuesFromSiteJsonUnitPlot(siteJsonUnitPlot){
		this._propertyBindingSelected?.dispose();
		this._propertyBindingSelected = PropertyBindingFactory.standard(this, siteJsonUnitPlot, 'selected', this._selectedChanged);
		this._plotNameElement.innerHTML = siteJsonUnitPlot.name;
		this._plotNumberElement.innerHTML = 'Plot '+String(siteJsonUnitPlot.number);
		this._plotStatusDescriptionElement.innerHTML = siteJsonUnitPlot?PlotStatus.getDescription(siteJsonUnitPlot.status):'&nbsp;';
		const showPrice = (siteJsonUnitPlot)&&(siteJsonUnitPlot.isAvailable);//(siteJsonUnitPlot)&&(!siteJsonUnitPlot.isSold)&&(!siteJsonUnitPlot.isReserved);
		this._plotPriceElement.innerHTML = (!showPrice)||(siteJsonUnitPlot.price<=0)?' ':siteJsonUnitPlot.priceString;
		const nBathroomString = this._configuration.showNBathrooms?` and ${siteJsonUnitPlot.nBathrooms} Bathrooms`:'';
		this._nBedroomsElement.innerHTML = ' - '+String(siteJsonUnitPlot.nBedrooms)+' Bedrooms'+nBathroomString;
		const hasConfiguratorOrTour=siteJsonUnitPlot&&Urls.getConfiguratorUrlForPlot(siteJsonUnitPlot, this._configuration);
		if(hasConfiguratorOrTour)
			this._buttonEnterHouse.classList.add('visible');
		else
			this._buttonEnterHouse.classList.remove('visible');
		
	}
	_selectedChanged(value){
		this._star.current.selected=value;
	}
	_handleClickSendBrochure(){
		this._callbackShowBrochureGenerationDialog({plot:this._siteJsonUnitPlot});
	}
	_handleClickEnterHouse(){
		this._callbackEnterHouse(this._siteJsonUnitPlot);
	}
	get element(){
		return this._element;
	}
	get sectionType(){
		return PlotDetailedInformationSectionType.Gallery;
	}
	_handleStarSelectedChanged(selected){
		if(selected)this._callbackAddFavourite(this._siteJsonUnitPlot);
		else this._callbackRemoveFavourite(this._siteJsonUnitPlot);
	}
	_handleClickShowStreetView(e){
		this._callbackShowStreetView({nearPlot:this._siteJsonUnitPlot});
	}
}